// RangeInput — min/max getalswaarde.

import React from 'react';
import { Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function RangeInput({ value, onChange, unit, disabled }) {
    const { t } = useTranslation();
    const v = value || { min: '', max: '' };
    const update = (key) => (ev) => onChange({ ...v, [key]: ev.target.value });

    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            <TextField
                label={`${t('input.range.min')}${unit ? ` (${unit})` : ''}`}
                type="number"
                inputMode="decimal"
                value={v.min}
                onChange={update('min')}
                disabled={disabled}
            />
            <TextField
                label={`${t('input.range.max')}${unit ? ` (${unit})` : ''}`}
                type="number"
                inputMode="decimal"
                value={v.max}
                onChange={update('max')}
                disabled={disabled}
            />
        </Stack>
    );
}
